import React from 'react';
import { PDFDownloadLink } from '@react-pdf/renderer';
import FileOpeningLedgerPdf from './FileOpeningLedgerPdf';

const FileOpeningLedgerPdfButton = ({ data }) => {
  return (
    <PDFDownloadLink document={<FileOpeningLedgerPdf data={data} />} fileName={`file-opening-ledger-${data.fileOpening.id}.pdf`}>
      {({ blob, url, loading, error }) =>
        loading ? 'Loading document...' : <button className="bg-blue-600 hover:bg-blue-700 text-white font-semibold px-4 py-2 rounded-md shadow">Download PDF</button>
      }
    </PDFDownloadLink>
  );
};

export default FileOpeningLedgerPdfButton;
